import React from 'react'


const FunFact = (props) => {

    const funfact = [
        {
            title: '10+',
            subTitle: 'MVP Exitosos',
        },
        {
            title: '50+',
            subTitle: 'Socios de Negocios',
        },
        {
            title: '100%',
            subTitle: 'Clientes Satisfechos',
        },
        {
            title: '4+',
            subTitle: 'Años de Experiencia',
        },
    ]


    return (
        <section className={`wpo-fun-fact-section  ${props.fnClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12" >
                        <div className="wpo-fun-fact-grids clearfix">
                            {funfact.map((funfact, fitem) => (
                                <div className="grid" key={fitem}>
                                    <div className="info">
                                        <h3>{funfact.title}</h3>
                                        <p>{funfact.subTitle}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FunFact;